import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

// TRV-2576: ruta pública /win-delivery exige queryParam 'tkn'; sin token redirige a login
@Injectable({ providedIn: 'root' })
export class WinDeliveryTokenGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const token = (route.queryParamMap.get('tkn') || '').trim();
    if (token) {
      return true;
    }
    this.router.navigate(['/auth/login']);
    return false;
  }
}
